import { adviserPracticeAdminCanSendRecommendationPackApi } from './canSendRecommendationPack';

export function adviserPracticeAdminApi(path: string) {
  return {
    path,
    canSendRecommendationPack: () =>
      adviserPracticeAdminCanSendRecommendationPackApi(`${path}/can-send-recommendation-pack`),
  };
}
